module.exports = __webpack_public_path__ + "static/img/code.17f9c268.png";